module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/013.d0656ae3.png";